import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss'; // Reusing the same SCSS for consistency
import { ReactComponent as Strengthen_weak_areasIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strengthen_weak_areas.svg';
import { ReactComponent as Reduce_overload_riskIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/reduce_overload_risk.svg';
import { ReactComponent as Improve_stabilityIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_stability.svg';
import { ReactComponent as Improve_techniqueIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_technique.svg';
import { ReactComponent as Improve_mobilityIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_mobility.svg';

interface InjuryPreventionStep2Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  improve_stability: <Improve_stabilityIcon />,
  improve_mobility: <Improve_mobilityIcon />,
  strengthen_weak_areas: <Strengthen_weak_areasIcon />,
  improve_technique: <Improve_techniqueIcon />,
  reduce_overload_risk: <Reduce_overload_riskIcon />,
};

// What prevention focus matters most?
export const InjuryPreventionStep2: FC<InjuryPreventionStep2Props> = ({ value, onNext }) => {
  const [selectedFocus, setSelectedFocus] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalPreferences?.groups?.find(
    (g: any) => g.goalId === 'injury_prevention',
  );

  const focuses = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>

      <div className="goal-buttons">
        {focuses.map((focus: any) => (
          <button
            key={focus.id}
            className={`goal-btn ${selectedFocus === focus.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedFocus(focus.slug);
              if (onNext) onNext(focus.slug);
            }}
          >
            <div className="goal-icon">{iconMap[focus.id]}</div>
            <span className="goal-label">{focus.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
